import React, { useRef } from 'react';
import { useOutsideAlerter } from '../../Utils/Utils';
import PopupMenu from '../PopupMenu';
import PopupMenuItem from '../PopupMenuItem';
import { DraftCommentStatusEnum, CommentActionEnum } from './CommentConstants';


const CommentActionMenu = ({ userRole, comment, onClick, resolveOnClick, onActionClick, handleClickAway, setPopupVisible }) => {
	const wrapperRef = useRef(null);
	useOutsideAlerter(wrapperRef, () => { setPopupVisible(false); handleClickAway() });

	const getCommentPermissions = (userRole, comment) => {
		return {
			userRoles: userRole,
			canComment: ["Peer", "Compliance", "Supervisor"].includes(userRole),
			canResolve: userRole === comment?.authorRole && (comment?.status === DraftCommentStatusEnum.RAISED),
			canPersist: ["Peer", "Compliance", "Supervisor"].includes(userRole),
		};
	};

	const userPermissions = getCommentPermissions(userRole, comment);

	return (
		<div ref={wrapperRef}>
			<PopupMenu /*width={118}*/ onClick={onClick}>
				{userPermissions.canResolve && <PopupMenuItem label="Resolve" onClick={resolveOnClick} />}
				{userPermissions.canPersist && !comment.isPersisted && <PopupMenuItem label="Keep for future publications" onClick={() => onActionClick(CommentActionEnum.PERSIST)} />}
				{userPermissions.canPersist && comment.isPersisted && <PopupMenuItem label="Remove from future publications" onClick={() => onActionClick(CommentActionEnum.UNPERSIST)} />}
			</PopupMenu>
		</div>
	);
}

export default CommentActionMenu;